import { render, staticRenderFns } from "./TaxInfoRequiredModal.vue?vue&type=template&id=003bd5b7&scoped=true"
import script from "./TaxInfoRequiredModal.vue?vue&type=script&lang=js"
export * from "./TaxInfoRequiredModal.vue?vue&type=script&lang=js"
import style0 from "./TaxInfoRequiredModal.vue?vue&type=style&index=0&id=003bd5b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003bd5b7",
  null
  
)

export default component.exports